import CommonService from "./common.service";

const cmIndustryTypeService = {
  listActive: () => CommonService.get("/master/cm-industry-types", {}, { silent: true }),
};

export default cmIndustryTypeService;
